<template src="./activityMySubjects.html"></template>

<script>
import TimetableRepository from '../../Repository/timetable'
import SubjectsRepository from '../../Repository/Subjects'
import { subjectTypes } from '../../Constants/Utils/Statics'
import CourseRepository from '../../Repository/courses';
import ValueAddedActivityRepository from '../../Repository/valueAddedActivity';
// import showStatus from '../../NetworkManager/showStatus'

export default {
  name: 'activityMySubjects',
  data() {
    return {
      allSubjectToShow: [],
      userData: null,
      isFielInstitute: false,
      selectedInstitute: '',
      selectedSemester: '',
      subjects: [],
      backgroundColor: "#E7E7FFCF",
      downArrow: "mdi-chevron-down",
      selectedFilter: '',
      getTimetableSubjects: [],
      selectedDeptFilter: '',
      depts: [],
      showSubjects: false,
      filteredSubjects: [],
      selectedSubjectFilter: '',
      selectedTypeFilterDBG: '',
      selectedTypeFilter: '',
      types: [],
      mainSelection: ["All", "Department wise", "Course Year wise", "Subject wise", "Type wise"],
      subjectTypes: subjectTypes,
      tempSubjects: [],
      filteredDeptsForCY: [],
      filteredCYs: [],
      selectedCYFilter: '',
      selectedDeptFilterCY: '',
      headers: [
        {
          text: 'Department',
          value: 'department',
          width: '20%'
        },
        {
          text: 'Course Year',
          value: 'courseYear',
          width: '20%'
        },
        {
          text: 'Division',
          value: 'division',
          width: '20%'
        },
        {
          text: 'Subject',
          value: 'subjectName',
          width: '20%'
        },
        // {
        //   text: 'Lecture Type',
        //   value: 'lectureType',
        //   width: '20%'
        // },
        {
          text: '',
          value: 'actions',
          width: '30%'
        }
      ],
      subjectsMapping: {},
      subjectFilters: {},
      type: "",
      isNicmar: false,
      isNaralkar: false,
      instituteIdsForNicmar: ["d26eac93-150f-446d-8708-8ce794361957", "25738fb8-0205-4b7e-ace2-96f8f940bb8d", "2e1691e6-f0bb-446d-b080-e0173d44af4c", "860153bb-3a42-4101-b3fb-8f08f684db90", "8e38d185-7cb0-42ba-bb19-04fdfacf819d", "f32c10d6-f25d-44b5-9fcb-e35e33e2aec2"]
    }
  },
  async created() {
    this.$store.commit('liveData/set_selectedActivityName', ' My Subjects')
    this.userData = this.$store.getters['user/get_userData']
    this.selectedInstitute = this.$store.getters[
      'instituteData/get_selectedInstitute'
    ]
    if (this.selectedInstitute === 'fc4eb82f-4ea3-4389-8db5-6dad8e0114c3') {
      this.isFielInstitute = true
    }
    if (this.selectedInstitute === 'a2459a84-980b-4f07-82da-7f1f45616c39') {
      this.isNaralkar = true
    }
    this.selectedSemester = this.$store.getters[
      'instituteData/get_selectedSemester'
    ]
    this.subjectsMapping = this.$store.getters["mappings/get_subjectsMapping"];
    this.timetableRepositoryInstance = new TimetableRepository(this)
    this.subjectsRepositoryInstance = new SubjectsRepository(this)
    this.CourseRepositoryInstance = new CourseRepository(this)
    this.ValueAddedActivityRepositoryInstance = new ValueAddedActivityRepository(this)

    // Call API to fetch subjects
    await this.fetchData()
    this.subjectFilters = this.$store.state.liveData.subjectFilters
    if (this.subjectFilters && this.subjectFilters?.filterBy) {
      this.selectedFilter = this.subjectFilters.filterBy
      if (this.subjectFilters.filterBy === "Department wise") {
        this.depts = this.subjectFilters.depts
        this.selectedDeptFilter = this.subjectFilters.department
        this.filterOnDept()
      } else if (this.subjectFilters.filterBy === "Course Year wise") {
        this.depts = this.subjectFilters.depts
        this.filteredDeptsForCY = this.subjectFilters.filteredDeptsForCY
        this.filteredCYs = this.subjectFilters.filteredCYs
        this.selectedCYFilter = this.subjectFilters.cy
        this.selectedDeptFilterCY = this.subjectFilters.cyDept
        this.filterOnCY()
      } else if (this.subjectFilters.filterBy === "Subject wise") {
        this.filteredSubjects = this.subjectFilters.filteredSubjects
        this.selectedSubjectFilter = this.subjectFilters.subject
        this.filterOnSubjects()
      } else if (this.subjectFilters.filterBy === "Type wise") {
        this.types = ["Division", 'Batch', 'Group']
        this.selectedTypeFilter = this.subjectFilters.type
        console.log('this.selectedTypeFilter.type', this.subjectFilters.type);
        this.filterOnType()
      }
    } else {
      this.selectedFilter = 'All'
      this.showSubjects = true
      this.allSubjectToShow = [...this.tempSubjects]
    }
  },
  methods: {
    async gotoSessionLectureMapping(subject, div) {
      let type;
      let groupInfo = {};
      if (div.division !== undefined && (div.batchName === undefined || div.batchName === '')) {
        type = 'Division'
        subject.division = div.division
        subject.batch = ''
      }
      if (div.batchName !== undefined && div.batchName !== '') {
        type = 'Batch'
        subject.division = div.division
        subject.batch = div.batchName
      }
      if (div.groupName !== undefined) {
        type = 'Group'
        groupInfo = div
        subject.division = ''
      }
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activitySessionToLectureMapping',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo
        }
      })
    },

    storeFiltersInLiveData(filterBy) {
      const filterObject = {
          filterBy: filterBy,
          department: this.selectedDeptFilter,
          courseYear: this.selectedCYFilter,
          division: this.selectedTypeFilter,
          subject: this.selectedSubjectFilter,
          type: this.selectedTypeFilter,
          cyDept: this.selectedDeptFilterCY,
          cy: this.selectedCYFilter,
          filteredSubjects: this.filteredSubjects,
          depts: this.depts,
          filteredDeptsForCY: this.filteredDeptsForCY,
          filteredCYs: this.filteredCYs
        }
        console.log('this.selectedTypeFilter', filterObject.type);
        this.$store.commit('liveData/set_subjectFilters', filterObject)
    },
    filterOnDept() {
      this.allSubjectToShow = [...this.tempSubjects.filter(subject =>
        subject.subjectDetails.department === this.selectedDeptFilter
      )];
        this.showSubjects = true
        this.storeFiltersInLiveData('Department wise')
    },
    filterCYS() {
      this.tempSubjects.forEach(subject => {
          if (subject.subjectDetails.department === this.selectedDeptFilterCY) this.filteredCYs.push(subject.subjectDetails.courseYear)
        })
        this.showSubjects = true
        this.storeFiltersInLiveData('Course Year wise')
    },
    filterOnCY() {
      this.allSubjectToShow = [...this.tempSubjects.filter(subject =>
        subject.subjectDetails.courseYear === this.selectedCYFilter
      )];
    },
    filterOnSubjects() {
      this.allSubjectToShow = this.tempSubjects.filter(subject => {
        return subject.subjectDetails.subjectName === this.selectedSubjectFilter;
      });
      console.log('this.allSubjectToShow', this.allSubjectToShow, this.tempSubjects);
        this.showSubjects = true
        this.storeFiltersInLiveData('Subject wise')
    },
    filterOnType() {
      if (this.selectedTypeFilter === 'Division') {
        this.$set(this, 'allSubjectToShow', this.tempSubjects.filter(subject => {
          return subject && subject.division && !subject.batchId;
        }));
      } else if (this.selectedTypeFilter === 'Batch') {
        this.allSubjectToShow = [...this.tempSubjects.filter(subject => subject && subject.batchId)];
      } else if (this.selectedTypeFilter === 'Group') {
        console.log('hereeee');
        this.allSubjectToShow = [...this.tempSubjects.filter(subject => subject && subject.groupId)];
      }
      this.showSubjects = true
      this.storeFiltersInLiveData('Type wise')
        console.log('this.allSubjectToShow2233', this.tempSubjects);
    },
    clearAllSelections() {
      this.selectedDeptFilter = ''
      this.selectedSubjectFilter = ''
      this.selectedTypeFilter = ''
      this.selectedCYFilter = ''
      this.selectedDeptFilterCY = ''
      this.showSubjects = false
      this.allSubjectToShow = []
      this.filteredSubjects = []
      this.filteredDeptsForCY = []
      this.filteredCYs = []
    },
    checkSelection() {
      this.clearAllSelections()
      this.depts = []
      this.selectedDeptFilter = ''
      if (this.selectedFilter === 'All') {
        this.showSubjects = true
        this.allSubjectToShow = [...this.tempSubjects]
      } else if (this.selectedFilter === 'Department wise' || this.selectedFilter === 'Course Year wise') {
        this.tempSubjects.forEach(subject => {
          this.depts.push(subject.subjectDetails.department)
        })
      } else if (this.selectedFilter === 'Subject wise') {
        this.tempSubjects.forEach(subject => {
          this.filteredSubjects.push(subject.subjectDetails.subjectName)
        })
      } else if (this.selectedFilter === 'Type wise') {
        this.types = ["Division", 'Batch', 'Group']
      }
    },
    async fetchData() {
      this.isNicmar = false
      if (this.instituteIdsForNicmar.includes(this.selectedInstitute)) {
        this.isNicmar = true
      }
      let valueAddedActivity = []
      try {
        valueAddedActivity = await this.ValueAddedActivityRepositoryInstance.getValueAddedActivityForFaculty({
          instituteId: this.selectedInstitute,
          semId: this.selectedSemester.semId,
          uId: this.userData.uId
        })
      } catch (error) {
        console.error('error', error);
      }

      try {
        this.allSubjectToShow = []
        if (this.selectedSemester.subjectAllocatedForDiv) {
          this.allSubjectToShow = [...this.selectedSemester.subjectAllocatedForDiv, ...this.selectedSemester.assignedGroupForSubject]
          this.tempSubjects = [...this.allSubjectToShow]
        } else {
          this.allSubjectToShow = [...this.selectedSemester.subjects, ...this.selectedSemester.assignedGroupForSubject]
          this.tempSubjects = [...this.allSubjectToShow]
        }
        const subjectIds = []

        this.allSubjectToShow.map((obj) => {
          subjectIds.push(obj.subjectId)
        })
        const getsubjectObjToPush = {
          instituteId: this.selectedInstitute,
          semId: this.selectedSemester.semId,
          subjectIds: subjectIds
        }
        const subject = await this.subjectsRepositoryInstance.getSubjectDetails(
          getsubjectObjToPush
        )
        const tempSubjects = []
        this.$store.commit("mappings/reset");
        const tempSubjects1 = []
        subject.map((obj) => {
          this.allSubjectToShow.map((data) => {
            if (obj.subjectId === data.subjectId) {
              data.subjectDetails = obj
              tempSubjects1.push(data)
            }
          })
          this.getTimetableSubjects = this.allSubjectToShow

          this.$store.commit('mappings/add_subjectsMapping', obj)
          obj.lectureType = this.subjectTypes[obj.subjectType]
          this.getTimetableSubjects.map((sub) => {
            if (obj.subjectId === sub.subjectId) {
              tempSubjects.push({
                ...obj,
                ...sub
              })
            }
          })
        })
        this.allSubjectToShow = [...tempSubjects1, ...valueAddedActivity]
        this.tempSubjects = [...this.allSubjectToShow]
        this.allSubjectToShow.sort((a, b) => {
            const subjectNameA = a?.subjectDetails?.subjectName?.toUpperCase();
            const subjectNameB = b?.subjectDetails?.subjectName?.toUpperCase();

            if (subjectNameA < subjectNameB) {
              return -1;
            }
            if (subjectNameA > subjectNameB) {
              return 1;
            }
            return 0;
          });
        this.subjects = [...tempSubjects, ...valueAddedActivity]
        this.userData.subjects = this.subjects
        this.$store.commit('user/set_userData', this.userData)
      } catch (err) {
        console.error(err)
        this.subjects = []
      }
    },
    async gotoAttendanceAnalysis(subject, info) {
      let type;
      let divisionName = '';
      let groupInfo = {};
      if (info.division !== undefined && (info.batchName === undefined || info.batchName === '')) {
        type = 'Division'
        divisionName = info.division
        subject.division = info.division
        subject.batch = ''
      }
      if (info.groupName !== undefined) {
        type = 'Group'
        groupInfo = info
      }
      if (info.batchName !== undefined && info.batchName !== '') {
        divisionName = info.division
        type = 'Batch'
        subject.division = info.division
        subject.batch = info.batchName
      }
      if (this.selectedInstitute === '6a2b6228-14b8-4d0b-8044-b55fe74240b3') {
        type = 'MultiDivision'
      }
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activityAttendanceAnalysis',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo,
          prop_divisionName: divisionName
        }
      })
    },
    async gotoTopics(subject, div) {
      let type;
      let groupInfo = {};
      if (div.division !== undefined && (div.batchName === undefined || div.batchName === '')) {
        type = 'Division'
        subject.division = div.division
        subject.batch = ''
      }
      if (div.batchName !== undefined && div.batchName !== '') {
        type = 'Batch'
        subject.division = div.division
        subject.batch = div.batchName
      }
      if (div.groupName !== undefined) {
        type = 'Group'
        groupInfo = div
        subject.division = ''
      }
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activityTopics',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo
        }
      })
    },
    gotoAssignments(subject, div) {
      let type;
      let groupInfo = {};
      if (div.division !== undefined && (div.batchName === undefined || div.batchName === '')) {
        type = 'Division'
        subject.division = div.division
        subject.batch = ''
      }
      if (div.batchName !== undefined && div.batchName !== '') {
        type = 'Batch'
        subject.division = div.division
        subject.batch = div.batchName
      }
      if (div.groupName !== undefined) {
        type = 'Group'
        groupInfo = div
        subject.division = ''
      }
      // subject.division = div.division
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activityAssignments',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo
        }
      })
    },
    gotoMyAssessments(subject, div) {
      let type;
      let groupInfo = {};
      if (div.division !== undefined && (div.batchName === undefined || div.batchName === '')) {
        type = 'Division'
        subject.division = div.division
        subject.batch = ''
      }
      if (div.batchName !== undefined && div.batchName !== '') {
        type = 'Batch'
        subject.division = div.division
        subject.batch = div.batchName
      }
      if (div.groupName !== undefined) {
        type = 'Group'
        groupInfo = div
        subject.division = ''
      }
      // subject.division = div.division
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activityAssessments',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo
        }
      })
    },
    gotoQuickTest(subject, div) {
      let type;
      let groupInfo = {};
      if (div.division !== undefined && (div.batchName === undefined || div.batchName === '')) {
        type = 'Division'
        subject.division = div.division
        subject.batch = ''
      }
      if (div.batchName !== undefined && div.batchName !== '') {
        type = 'Batch'
        subject.division = div.division
        subject.batch = div.batchName
      }
      if (div.groupName !== undefined) {
        type = 'Group'
        groupInfo = div
        subject.division = ''
      }
      // subject.division = div.division
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activityQuickTest',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo
        }
      })
    },
    gotoStudyMaterial(subject, div) {
      let type;
      let groupInfo = {};
      if (div.division !== undefined && (div.batchName === undefined || div.batchName === '')) {
        type = 'Division'
        subject.division = div.division
        subject.batch = ''
      }
      if (div.batchName !== undefined && div.batchName !== '') {
        type = 'Batch'
        subject.batch = div.batchName
        subject.division = div.division
      }
      if (div.groupName !== undefined) {
        type = 'Group'
        groupInfo = div
        subject.division = ''
      }
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activityStudyMaterial',
        params: {
          prop_subject: subject,
          prop_type: type,
          prop_groupInfo: groupInfo
        }
      })
    },
    gotoCourse(subject, div) {
      subject.division = div.division
      this.$store.commit('liveData/set_selectedSubject', subject)
      this.$router.push({
        name: 'activitySubjectCourses',
        params: {
          prop_subject: subject
        }
      })
    }
  }
}
</script>

<style src="./activityMySubjects.css"></style>
